import type { AppContextValue } from 'src/components/app-context';
import { AppContext } from 'src/components/app-context';
import React from 'react';
import { Link } from 'react-router-dom';
import type { CategoryTreeListingFragment } from 'src/types';

import * as S from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

interface CategoryTreeListingProps
  extends Pick<CategoryTreeListingFragment, 'categoryTree'> {
  brand: {
    id: number;
  };
}

class CategoryTreeListing extends React.PureComponent<CategoryTreeListingProps> {
  declare context: AppContextValue;

  linkToBrandCategory(
    category: NonNullable<CategoryTreeListingProps['categoryTree']>[number],
    brand: { id: number }
  ) {
    return this.context.linkTo('brandCategory', {
      ...category,
      brandId: brand.id,
    });
  }

  renderTree(
    category: NonNullable<CategoryTreeListingProps['categoryTree']>[number],
    depth = 0
  ) {
    const { brand } = this.props;
    const { t } = this.context;
    const toHeader = this.linkToBrandCategory(category, brand);
    return (
      <S.Category key={category!.id}>
        <Link
          to={toHeader}
          onClick={() => {
            trackInternalNavigationClick({
              scope: InternalNavigationScope.BRAND_CATEGORY_TREE,
              nextPage: toHeader,
            });
          }}
        >
          {depth === 0 ? <h3>{category!.name}</h3> : <h4>{category!.name}</h4>}
          {!category!.children && (
            <p>
              {t('header', 'mega-menu.show-all-in-category', {
                name: category!.name!,
              })}
            </p>
          )}
        </Link>
        {category?.children &&
          category.children.map(child => {
            const to = this.linkToBrandCategory(
              child as NonNullable<
                CategoryTreeListingProps['categoryTree']
              >[number],
              brand
            );
            return child!.children || depth === 0 ? (
              this.renderTree(
                // This assertion is mandatory as nested gql types this way are too much of a pain to work with as virtually every field is optional
                // The check 'category?.children' above ensures that we don't run into errors here
                // This is not a good solution but the issue lies far deeper
                child as NonNullable<
                  CategoryTreeListingProps['categoryTree']
                >[number],
                depth + 1
              )
            ) : (
              <Link
                to={to}
                key={child!.id}
                onClick={() =>
                  trackInternalNavigationClick({
                    scope: InternalNavigationScope.BRAND_CATEGORY_TREE,
                    nextPage: to,
                  })
                }
              >
                {child!.name}
              </Link>
            );
          })}
      </S.Category>
    );
  }

  render() {
    const { categoryTree } = this.props;
    return <S.Block>{categoryTree!.map(cat => this.renderTree(cat))}</S.Block>;
  }
}

CategoryTreeListing.contextType = AppContext;

export default CategoryTreeListing;
